import React, { useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import LoginInfo from "./LoginInfo";
import LogoImage from "../../../images/dried-mango-logo.svg";
import "./login.css";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../../components/shared/buttons/button";
import ViewPassword from "../../../images/eye-icon.svg";
import HidePassword from "../../../images/eye-off.svg";
import { useSelector, useDispatch } from "react-redux";
import { clearRedirectPath, setPermissions, setUserRole, setUserTimezone } from "../../../app/globalSlice";
import { toast } from "react-hot-toast";
import { useLoginUserMutation } from "../authApi";
import { getCurrentLanguage, showToast } from "../../../helpers/Utils";
import i18next from "i18next";
import LanguageToggleSwitch from "../../../components/shared/LanguageToggleSwitch/LanguageToggleSwitch";
import useTranslator from "../../../hooks/useTranslator";
import { normalizeTimezone } from "../../../helpers/timezoneUtils";

const Login = () => {
  const { _t } = useTranslator();
  const [showPassword, setShowPassword] = useState(false);
  const redirectPath = useSelector((state) => state.global.redirectPath);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // localStorage.clear();
  }, []);
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const [loginUser, { isLoading, isError }] = useLoginUserMutation();

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await loginUser(credentials).unwrap();
      // console.log(result);
      if (result && result?.data) {
        localStorage.setItem("authToken", result?.data?.token);
        // ########### Saved In Redux ###########
        dispatch(setPermissions(result?.data?.permissions || [])); 
        dispatch(setUserRole(result?.data?.role_name || []));
        
        // Store timezone (from response or fallback to browser timezone)
        const userTimezone = normalizeTimezone(
          result?.data?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
        );
        dispatch(setUserTimezone(userTimezone));
        localStorage.setItem("userTimezone", userTimezone);

        dispatch(clearRedirectPath());
        navigate(redirectPath);
      } else if (
        result &&
        result?.message ===
          "Your account has been created. Please check your email to set your password."
      ) {
        showToast(
          "Your account has been created. Please check your email to set your password.",
          "success"
        );
      } else {
        showToast("Login failed. Please verify your email and password are correct.", "error");
      }
    } catch (error) {}
  };

  return (
    <Row className="m-0">
      <Col lg={6} className="p-0">
        <div className="login_wrapper d-flex justify-content-center align-items-center min-vh-100">
          <div className="login_form">
            <img src={LogoImage} alt="logo" className="img-fluid" />
            <div className="d-flex align-items-center w-full justify-content-between">
              <h1>{_t("login", "Login")}</h1>
              <LanguageToggleSwitch />
            </div>
            <p className="pt-1">
              {_t(
                "see_what_is_going_on_with_your",
                "See what is going on with your"
              )}{" "}
              <span className="hightlight">{_t("business", "business")}</span>
            </p>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3 cmn_input">
                <Form.Label>{_t("e-mail", "E-mail")}</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="example@gmail.com"
                  name="email"
                  value={credentials.email}
                  onChange={handleChange}
                  autoComplete="username"
                />
              </Form.Group>
              <Form.Group className="mb-3 cmn_input">
                <Form.Label>{_t("password", "Password")}</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="************"
                    name="password"
                    value={credentials.password}
                    onChange={handleChange}
                    autoComplete="current-password"
                  />
                  <span
                    className="view_pass"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <img
                      src={showPassword ? ViewPassword : HidePassword}
                      alt="eye"
                    />
                  </span>
                </div>
              </Form.Group>
              <div className="d-flex justify-content-end mb-4">
                <Link className="hightlight forgetPass" to="/forgot-password">
                  {_t("forgot_password", "Forgot Password")}
                </Link>
              </div>
              <Button
                label={
                  isLoading
                    ? `${_t("logging_in", "Logging in")}...`
                    : _t("login", "Login")
                }
                size="medium"
                className="w-100"
                type="submit"
              />
            </Form>
          </div>
        </div>
      </Col>
      <Col lg={6} className="p-0">
        <div className="info_wrapper min-vh-100 d-flex justify-content-center align-items-center overflow-hidden position-relative">
          <LoginInfo />
        </div>
      </Col>
    </Row>
  );
};

export default Login;
